import { get } from '@eika-infrastruktur/request';
import type { NameAndUrl } from '@generated-types';
import type { PdfKey } from '@react-query/types';
import { getApiUrl } from '@react-query/utils';

export const getPdfNameAndUrl = (pdfKey: PdfKey): Promise<NameAndUrl> => get(getApiUrl(`pdf-name-and-url/${pdfKey}`));
